const productCategoryForFabrication = [
  "Glow Sign Boards",
  "ACP Sign Board",
  "Lollipop Signage",
  "3D letters",
  "Flex Frame Signage",
  "Aluminium Backlit Signage",
];

const productCategoryForPrinting = [
  "Solvent Print",
  "Ecosolvent Printing",
  "UV Print",
  "Latex Printing",
  "Plotter Cutting Printing",
  "Vinyl Branding",
  "POS",
];
export const combinedCategories = [
  ...productCategoryForFabrication,
  ...productCategoryForPrinting,
];
